unable to read source [project]/packages/site-core/node_modules/@finbackoffice/fe-core/src/constants/sportTypes.ts